/* eslint-disable no-unused-expressions */
import { useState, useEffect } from 'react';
import { mortgageRateAPI } from './mortgageRateAPI';

export const useMortgageRateApi = ({
    productCodes = [],
}) => 
{
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const controller = new AbortController()

    const abort = () => 
    {
        controller.abort();
        if (isLoading) setIsLoading(false)
    }

    useEffect(() => 
    {
        const runFetch = async () => 
        {
            try 
            {
                const responseData = await mortgageRateAPI([...productCodes], { signal: controller.signal })
                if (isLoading) setData(responseData)
            }
            catch (e) 
            {
                if (e?.name !== 'AbortError') 
                {
                    // eslint-disable-next-line no-console
                    console.error('useMortgageRateApi error', e)
                    setError(e);
                }
            } 
            finally 
            {
                setIsLoading(false);
            }
        };

        if (isLoading) runFetch();

        return () => abort()
    }, [
        controller, 
        data,
        isLoading,
        error,
        setData,
        setIsLoading,
        setError,
        abort,
    ]);

    return {
        data,
        isLoading,
        error,
        abort
    };
};
